<template>
    <div class="accessories-price">
        <h3>{{translate('accessories_in_price')}}</h3>
        <ul>
            <li class="included-list-products" v-for="element in accessories">
                <span class="icon-ok"/>
                <span class="product-tilte">{{translate(element.title)}}</span>
            </li>
        </ul>
    </div>

</template>

<script>
    export default {
        name: "accessories_in_price",
        methods:{
            toggleAdditionalAccessories(id) {

                this.$store.commit({
                    type: 'toggleIncludedAccessories',
                    id: id
                });
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
        },

        computed: {
            accessories() {
                return this.$store.state.productCard.custom.accesories.values.included_accessories.values;
            }
        }

    }
</script>